export default __webpack_public_path__ + "static/media/softclix_lancing_kit.2164ca4b.webp";